import api from "@/api";
import cookie from "@/api/cookie";
import router from "@/router";

const state = {
	token: '',
	userInfo: null,
	websiteInfo: null,
};

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	SET_USERINFO: (state, data) => {
		state.userInfo = data;
	},
	
	SET_WEBSITE_INFO: (state, data) => {
		state.websiteInfo = data;
	},
};

const actions = {
	
	// get user info
	async getUserInfo({commit}) {
		let res = await api[process.env.VUE_APP_WEB == 1 ? 'userAdmin' : 'user'].info();
		commit("SET_USERINFO", res.data);
		return res;
	},
	
	async getWebsiteInfo({commit}, {subjectId, defaultUi}) {
		let ui = {};
		if (subjectId) {
			let res = await api.option.get({name: 'info', subjectId});
			ui = res.data;
		}
		commit('SET_WEBSITE_INFO', Object.assign(defaultUi,ui))
		return Object.assign(defaultUi,ui);
	},
	
	// user logout
	logout({commit}) {
		commit('SET_TOKEN', '');
		cookie.removeToken();
		router.replace("/login");
	},
	
	
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
